import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import { __ } from '@wordpress/i18n';

const sliders = document.querySelectorAll('.block-tr-announcement .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation, Pagination],
			slideClass: 'block-content',
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: slider.parentElement.querySelector('.swiper-pagination'),
				type: 'fraction',
				renderFraction: (currentClass, totalClass) => {
					return `<span class="${currentClass}"></span> ${__('of', 'propel')} <span class="${totalClass}"></span>`;
				},
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
		};

		new Swiper(slider, settings);
	});
}
